import React from "react";
import { FaFingerprint, FaArrowRight } from "react-icons/fa";
import "./HomoglyphFindings.css";

const SOURCE_LABEL = {
  sender: "Sender",
  "reply-to": "Reply-To",
  url: "Link",
};

/**
 * Renders look-alike / homoglyph domains detected against the org's protected
 * domains. Driven by the `homoglyphs` field returned by both analysis routes.
 * Each finding shows the impersonating domain, where it appeared, the technique,
 * and the protected domain it mimics.
 */
export default function HomoglyphFindings({ homoglyphs }) {
  const findings = homoglyphs?.findings;
  if (!Array.isArray(findings) || findings.length === 0) return null;

  return (
    <div className="hgf-block">
      <div className="hgf-title">
        <FaFingerprint />
        <span>Homoglyphs</span>
        <span className="hgf-count">{findings.length} look-alike{findings.length === 1 ? "" : "s"}</span>
      </div>
      <p className="hgf-intro">
        A domain in this email closely resembles one of your organization's protected domains —
        a common impersonation tactic. Treat the sender as untrusted until verified.
      </p>
      <ul className="hgf-list">
        {findings.map((f, i) => (
          <li key={`${f.domain}-${i}`} className={`hgf-item hgf-${f.severity || "medium"}`}>
            <div className="hgf-item-head">
              <span className={`hgf-source hgf-source-${f.source}`}>
                {SOURCE_LABEL[f.source] || f.source}
              </span>
              <span className="hgf-domain hgf-bad">{f.domain}</span>
              <FaArrowRight className="hgf-arrow" />
              <span className="hgf-domain hgf-good">{f.matched}</span>
              {f.matchedLabel && <span className="hgf-label">{f.matchedLabel}</span>}
              <span className={`hgf-sev hgf-sev-${f.severity || "medium"}`}>
                {(f.severity || "medium").toUpperCase()}
              </span>
            </div>
            <div className="hgf-technique">
              {f.techniqueLabel}
              {f.reason ? ` — ${f.reason}` : ""}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
